// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1tLv-","large":"styles_large__12SGc"};